import React, {Component} from "react";
import {Row, Col, Icon, Button} from 'antd';
import PropTypes from 'prop-types';
import style from '../index.css';

/**
 * 最后步骤——完成
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-10 16:04:36
 * Version: 1.0
 * Modify log:
 */
class LastStep extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {update, status, onReset} = this.props;

        return (
            <div>
                <Row type="flex" justify="center" align="middle">
                    <Col span={12} style={{textAlign:'center'}}>
                        {
                            this.props.status ? <Icon type="check-circle" className={style["finish-circle-success"]}/>
                                : <Icon type="check-circle" className={style["finish-circle-failed"]}/>
                        }
                    </Col>
                </Row>
                <Row type="flex" justify="center" align="middle">
                    <Col span={12} style={{textAlign:'center'}}>
                        <p style={{margin:'1rem 0'}} className={style["finish-tip-title"]}>
                            {this.props.status ? '设置成功' : '设置失败'}
                        </p>
                    </Col>
                </Row>
                <Row type="flex" justify="center" align="middle">
                    <Col span={12} style={{textAlign:'center'}}>
                        <p style={{margin:'0 0 1rem'}}>
                            {status && !update ? '迎新流程配置完成，可返回列表或继续添加'
                                : status && update ? '迎新流程配置完成，返回列表点击查看配置详情' : '迎新流程配置失败，请重新配置！'}
                        </p>
                        <div>
                            {
                                !update ?
                                    <Button type={'primary'} onClick={onReset}>
                                        {status ? '继续添加' : '重新配置'}
                                    </Button>
                                    : null
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

LastStep.defaultProps = {
    update: false,
    status: false, //是否配置成功
}

LastStep.propTypes = {
    update: PropTypes.bool, //是否是修改操作
    status: PropTypes.bool, //是否配置成功
    onReset: PropTypes.func //重置回调
}

export default LastStep;


// WEBPACK FOOTER //
// ./components/lcgl/lcpz/edit-form/step-last.js